import React, { useEffect, useRef, useState } from 'react';

const initialButtons = [
  { label: '스포츠' },
  { label: '실시간 스포츠' },
  { label: '카지노' },
  { label: '슬롯' },
  { label: '미니게임' },
  { label: '가상게임' },
  { label: '홀덤' },
  { label: '로투스' },
  { label: '크라운' },
  { label: 'MGM' },
];

const NewResultTabButtons = ({ onTabChange }) => {
  const [activeIndex, setActiveIndex] = useState(4); // Default "미니게임"
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
  const buttonRefs = useRef([]);

  // Initialize refs array
  useEffect(() => {
    buttonRefs.current = buttonRefs.current.slice(0, initialButtons.length);
  }, []);

  useEffect(() => {
    const activeBtn = buttonRefs.current[activeIndex];
    setTimeout(() => {
      if (activeBtn) {
        const { offsetLeft, offsetWidth } = activeBtn;
        setIndicatorStyle({ left: offsetLeft, width: offsetWidth });
      }
    }, 100);
  }, [activeIndex]);

  const handleClick = (index) => {
    setActiveIndex(index);
    if (onTabChange) {
      onTabChange(initialButtons[index].label);
    }
  };

  return (
    <div className="overflow-auto">
      <div className="w-max relative">
        {/* Background pill */}
        <div
          className="bg-red-500 absolute h-[38px] rounded-full transition-all duration-300 ease-in-out"
          style={{
            left: indicatorStyle.left,
            width: indicatorStyle.width,
          }}
        />
        {initialButtons.map((button, index) => (
          <button
            key={index}
            ref={(el) => {
              buttonRefs.current[index] = el;
            }}
            onClick={() => handleClick(index)}
            className={`relative z-10 font-KoreanTITGD px-4 h-[38px]  rounded-full text-sm font-bold transition-all duration-300 ${
              index === activeIndex ? 'text-black' : 'text-white'
            }`}
          >
            {button.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NewResultTabButtons;
